import { DefaultLanguage } from '../translations/i18n';
export const DefaultPrivacyPolicyUrl = 'https://net2phone.com/privacy-policy';


export interface ITenantConfig {
  language: string;
  net2PhoneUrl: string;
  privacyPolicyUrl?: string;
}

export class DefaultTenantConfig implements ITenantConfig {
  language: string = DefaultLanguage;
  net2PhoneUrl: string = 'https://www.net2phone.com';
  privacyPolicyUrl: string = DefaultPrivacyPolicyUrl;
}
